<template>
  <v-dialog persistent v-model="showDialog" max-width="700px">
    <v-card flat>
      <v-icon class="close" @click="closeModal">$sl-close</v-icon>
      <!-- <div class="title-icon">
        <div class="overline">{{ item.parentName}}</div>
        <v-icon small @click="closeModal">$sl-close</v-icon>
      </div>-->
      <div class="overline">{{ item.parentName}}</div>
      <h2 class="mt-2">{{ item.name}}</h2>
      <p class="pt-2">
        <b>
          {{$t('ebook.education-profModalText1')}}
          <u
            v-if="item.isRequired"
          >{{$t('ebook.education-profModalText2')}}</u>
          <u v-else>{{$t('ebook.education-profModalText2-2')}}</u>
          {{$t('ebook.education-profModalText3-2', {name: apprenticeName != '' ? apprenticeName : $t('company.you')})}}
          <i>{{ item.parentName}}.</i>
        </b>
      </p>
      <h6>{{$t('ebook.education-profModalText4')}}</h6>
      <p>
        {{ apprenticeName != '' ? apprenticeName : $t('company.you') }} {{ $t('ebook.education-profModalText5-2') + " " + item.requiredLevel }}
        {{$t('ebook.education-profModalText6')}}
      </p>

      <h6 
        v-if="item"
      >{{ apprenticeName != '' ? apprenticeName : $t('company.you') }} {{$t('ebook.education-profModalText7-2')}} {{item.maxInstructorSkillEstimatedLevel ? item.maxInstructorSkillEstimatedLevel : '0'}}</h6>

      <template v-if="item">
        <KnowledgeBoxes
          :isApprentice="true"
          :elem="item"
          @knowledgeClick="knowledgeClick()"
          :radiobuttons="false"
        ></KnowledgeBoxes>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import KnowledgeBoxes from '@/components/Common/Ebook/KnowledgeBoxes'
import API from '@/services/api.js'

// @group Ebook
// Styled EbookProfessionInfoModal component
export default {
  name: 'EbookProfessionInfoModal',

  props: {
     //is modal showed
    show: {
        // `true` / `false`
      type: Boolean,
      // The default value is: `false`
      default: false
    },
    //has element
    element: {
      // `Object`
      type: Object
    },
    apprenticeName: {      
      type: String,      
      default: ''
    },
  },
  data: () => ({
    item: {},
    showDialog: false
  }),

  components: {
    KnowledgeBoxes
  },

  created() {
    this.init()
  },

  watch: {
    show(val) {
      this.showDialog = val
    },
    element() {
      this.init()
    }
  },

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isApprentice', 'isInstructor'])
  },

  filters: {},
  methods: {
    init() {
      this.item = this.element
      this.item.subElement = {
        level1Text: this.element.level1Text,
        level2Text: this.element.level2Text,
        level3Text: this.element.level3Text,
        level4Text: this.element.level4Text
      }
    },
    knowledgeClick() {},
    closeModal() {
      //modalAdd=!modalAdd

       // Fire go back
      // @arg The argument is a object representing report
      this.$emit('close')
      this.showDialog = false
    }
  }
}
</script>

<style lang="scss">
// .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
//   &.active {
//     background-color: rgb(73, 69, 69) !important;
//     color: #fff !important;
//     svg {
//       fill: #fff;
//     }
//   }
// }

// .v-list.skills {
//   padding: 0;
//   .icon_style {
//     width: 35px;
//     height: 35px;
//   }
//   .v-list-item {
//     &.skill1 {
//       // background-color: rgb(227, 227, 227, 0.5);
//       &.active {
//         background-color: rgb(73, 69, 69) !important;
//         color: #fff !important;
//       }
//     }
//     &.skill2 {
//       //background-color: rgb(202, 163, 163, 0.5);
//       &.active {
//         background-color: red !important;
//         color: #fff !important;
//       }
//     }
//     &.skill3 {
//       //background-color: rgba(221, 234, 99, 0.2);
//       &.active {
//         background-color: rgba(182, 109, 1, 0.836) !important;
//         color: #fff !important;
//       }
//     }
//     &.skill4 {
//       //background-color: rgb(174, 219, 159, 0.5);
//       &.active {
//         color: #fff !important;
//         background-color: green !important;
//       }
//     }
//     &__content.description {
//       font-size: 12px;
//       min-height: 50px;
//     }
//   }
// }
// .element {
//   color: #fff !important;
//   background-color: #7a7a7a !important;
//   .v-card {
//     &__text {
//       height: 65px !important;
//       justify-content: center;
//       svg {
//         fill: #fff;
//       }
//     }
//     &__title {
//       color: #fff !important;
//     }
//   }
// }
// .description {
//   font-size: 14px;
// }
</style>
